import React, { useContext } from 'react';
import FieldLabel from '@react/react-spectrum/FieldLabel';
import { Picker, Item } from '@adobe/react-spectrum';

import { useMarketoInstances } from 'root/hooks';
import { QuickSetupContext } from './Context';
import { FeaturesContext } from '../../features/FeaturesContext';

export default function AdditionalParamaters() {
  const { context, setContextValue } = useContext(QuickSetupContext);

  const { isFeatureEnabled, SOURCES_CONFIGURATION } =
    useContext(FeaturesContext);
  const marketoInstances = useMarketoInstances();

  const options = marketoInstances
    .filter((marketo) => marketo.imsOrg?.id === context.environment?.imsOrg?.id)
    .map((marketo) => ({
      value: marketo.url,
      munchkinId: marketo.details?.munchkinId && marketo.details.munchkinId,
      salesforceOrgId:
        marketo.details?.salesforceOrgId && marketo.details.salesforceOrgId
    }));

  const isDisabled = options.length ? false : true;

  const disabledKeys = options
    .filter((e) => !e.munchkinId && !e.salesforceOrgId)
    .map((e) => e.value);

  const onChange = (value) =>
    setContextValue({
      path: `additionalParams`,
      value: marketoInstances
        .filter((e) => e.url === value)
        .map((e) => ({
          marketoId: e.id
        }))
        .flat()[0]
    });

  return (
    <>
      {isFeatureEnabled(SOURCES_CONFIGURATION) &&
        context.selectedValues?.sources?.channels.includes('marketo') && (
          <FieldLabel label="Marketo" necessity="required">
            <Picker
              items={options}
              disabledKeys={disabledKeys}
              onSelectionChange={onChange}
              isDisabled={isDisabled}>
              {(item) => (
                <Item key={item.value}>
                  {item.munchkinId && item.salesforceOrgId
                    ? item.value
                    : `${item.value} (Marketo configuration details are missing)`}
                </Item>
              )}
            </Picker>
            {isDisabled && (
              <div className="field-description">
                <em>
                  Marketo configuration is missing, please contact{' '}
                  <a href="mailto:demosystem@adobe.com">demosystem@adobe.com</a>
                </em>
              </div>
            )}
          </FieldLabel>
        )}
    </>
  );
}
